const UTILITY_TYPE_DISPLAY: Record<string, string> = {
    electric: 'Electric',
    gas: 'Gas',
    gas_and_electric: 'Gas & Electric',
    water: 'Water',
    internet: 'Internet',
    trash: 'Trash',
    cleaning: 'Cleaning',
    security: 'Security',
    other: 'Other',
};

export function formatUtilityType(utilityType: string): string {
    return UTILITY_TYPE_DISPLAY[utilityType] ?? utilityType;
}

/** Joins a roster/bill's utility type array into a single display string, e.g. ["electric","gas"] -> "Electric & Gas". */
export function formatUtilityTypes(utilityTypes: string[]): string {
    return (utilityTypes ?? []).map(formatUtilityType).join(' & ');
}
